import React from "react";
import defaultRowRenderer from "react-virtualized/dist/commonjs/Table/defaultRowRenderer";
import Table from "react-virtualized/dist/commonjs/Table/Table";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import Cell from "../Cell";
import Button from "react-bootstrap-3/es/Button";
import { SHARING_TYPE } from "../../../Common/constants";
import SwapArrow from "../../../icons/swapArrow";
import styled from "styled-components";

function toggleClick({ onToggle, ...props }) {
  return event => onToggle({ event, ...props });
}

const StyledSwapArrow = styled(SwapArrow)`
  height: 18px;
  width: 18px;
`;

export function defaultCellRenderer({
  cellData,
  columnData,
  columnIndex,
  dataKey,
  isScrolling,
  rowData,
  rowIndex,
  field,
  validation,
  entities,
  renderers,
  onToggle,
  onDelete,
  onEdit,
  customActions,
}) {
  // if (cellData == null) {
  //   return "";
  // }
  let onClick = undefined;
  const disabled =
    typeof field.disabled === "function" ? field.disabled({ entity: rowData }) : field.disabled;

  if (onToggle && field.toggleAction && !disabled) {
    onClick = toggleClick({ onToggle, field, entity: rowData, idx: rowIndex });
  }
  return (
    <div className="burgi" onClick={onClick}>
      <Cell
        field={field}
        entity={rowData}
        validation={validation}
        entities={entities}
        renderers={renderers}
      />
    </div>
  );
}

const DragHandle = SortableHandle(({ entity }) => (
  <Button bsClass="btn btn-default btn-sm mr" data-tip="React-tooltip" data-for="drag">
    <StyledSwapArrow />
  </Button>
));

const CustomAction = ({ customAction, entity, index }) => {
  if (customAction.isAvailable) {
    if (!customAction.isAvailable({ entity })) {
      return null;
    }
  }

  return (
    <Button
      bsClass={`btn btn-default ${customAction.classNames} btn-sm mr`}
      onClick={event => customAction.onExecute({ event, entity, index })}
      data-tip="React-tooltip"
      data-for={customAction.tooltipId}>
      <em
        className={`${
          typeof customAction.icon === "function"
            ? customAction.icon({ entity })
            : customAction.icon
        }`}
      />
    </Button>
  );
};

export function actionsRenderer({
  cellData,
  columnData,
  columnIndex,
  dataKey,
  isScrolling,
  rowData: entity,
  rowIndex: idx,
  field,
  validation,
  entities,
  renderers,
  onToggle,
  onDelete,
  onEdit,
  onClone,
  customActions,
  sortable,
  allowClone,
  reorder,
  allowDelete = true,
  allowEdit = true,
}) {
  let deleteButton = (
    <Button
      bsClass="btn btn-danger btn-sm mr"
      onClick={event => onDelete({ event, entity, idx })}
      data-tip="React-tooltip"
      data-for="delete">
      <em className="fa fa-trash-o" />
    </Button>
  );

  const shared =
    entity.sharingType && entity.sharingType === SHARING_TYPE.SHARED && entity.parentPropertyTicker;

  if (shared || allowDelete === false || entity.allowDelete === false) {
    deleteButton = null;
  }
  return (
    <div>
      {reorder && <DragHandle entity={entity} />}
      {allowClone && (
        <Button
          bsClass="btn btn-default btn-sm mr"
          onClick={event => onClone({ event, entity, idx })}
          data-tip="React-tooltip"
          data-for="clone">
          <em className="fa fa-copy" />
        </Button>
      )}
      {shared ? (
        <Button
          bsClass="btn btn-default btn-sm mr"
          onClick={event => onEdit({ event, entity, idx })}
          data-tip="React-tooltip"
          data-for="sharing">
          <em className="fa fa-eye" />
        </Button>
      ) : (
        allowEdit && (
          <Button
            bsClass="btn btn-default btn-sm mr"
            onClick={event => onEdit({ event, entity, idx })}
            data-tip="React-tooltip"
            data-for="edit">
            <em className="fa fa-pencil" />
          </Button>
        )
      )}

      {deleteButton}

      {!shared &&
        customActions &&
        customActions.map((customAction, index) => (
          <CustomAction
            key={`customAction${index}`}
            customAction={customAction}
            entity={entity}
            index={index}
          />
        ))}
    </div>
  );
}

class TableWrapper extends React.Component {
  render() {
    return (
      <Table
        ref={instance => {
          this.Table = instance;
        }}
        {...this.props}
      />
    );
  }
}

export const SortableTable = SortableContainer(TableWrapper, { withRef: true });

// SortableElement omits the index property due to inner workings,
// we build an alias and then pass it through to the defaultRowRenderer
export const SortableTableRowRenderer = SortableElement(({ i, ...props }) => {
  props.index = i;
  return defaultRowRenderer(props);
});

// The z-index is to avoid the row disappearing when dragging.
// Check https://github.com/clauderic/react-sortable-hoc/issues/87
// The index is to avoid a limitation of SortableElement
export function RowRenderer(props) {
  const { index, style, ...rest } = props;
  let extraStyles = {
    borderBottom: "1px solid #eee",
    zIndex: 112,
  };
  if (index % 2 === 0) {
    extraStyles = {
      ...extraStyles,
    };
  } else {
    extraStyles = {
      ...extraStyles,
      backgroundColor: "#fafbfc",
    };
  }
  return (
    <SortableTableRowRenderer
      index={index}
      i={index}
      style={{
        ...style,
        ...extraStyles,
      }}
      {...rest}
    />
  );
}

export function HeaderRowRenderer({ className, columns, style }) {
  let extraStyles = {
    borderBottom: "1px solid #eee",
    backgroundColor: "rgb(250, 251, 252)",
  };
  return (
    <div
      className={className}
      role="row"
      style={{
        ...style,
        ...extraStyles,
      }}>
      {columns}
    </div>
  );
}
